import { render, staticRenderFns } from "./F10Behavior.vue?vue&type=template&id=24798a66&scoped=true"
import script from "./F10Behavior.vue?vue&type=script&lang=js"
export * from "./F10Behavior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24798a66",
  null
  
)

export default component.exports